/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-22 17:40:06
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-23 11:57:13
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAnimation/Item/index.tsx
 */
import React from 'react';
import CountWords from '@/src/components/CountWords/CountWords';
import { ItemWrapper } from '@/src/components';
import { Row, SectionContainer } from '@/src/components/Layouts';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { RadioGroup, RadioItem, Input, Select } from 'src/components/Antd';
import { Space } from 'antd';
import {
  AnimationEffection,
  AnimationType,
  EntranceOption,
  fadeDirection,
  HoverEffect,
  slideDirection,
  zoomDirection,
} from '../tool';

import styles from './style.less';
import { useDispatch } from 'react-redux';
import { onChangeField } from '../slice';
import { ANIMATION_PREFIX } from '@/src/tools/constant';

function Item(props: any) {
  const { animation, errorProcessingProps } = props;
  const { specificError } = errorProcessingProps;
  //console.log('animation', animation);
  const _d = useDispatch();

  const renderOptionsByEffectType = () => {
    const value = animation.effect;
    switch (value) {
      case AnimationEffection.FADE:
        return [
          { label: 'Fade In', value: fadeDirection.FADE_IN },
          { label: 'Fade In Down', value: fadeDirection.FADE_IN_DOWN },
          { label: 'Fade In Up', value: fadeDirection.FADE_IN_UP },
          { label: 'Fade In Left', value: fadeDirection.FADE_IN_LEFT },
          { label: 'Fade In Right', value: fadeDirection.FADE_IN_RIGHT },
        ];
      case AnimationEffection.SLIDE:
        return [
          { label: 'Slide In Down', value: slideDirection.SLIDE_IN_DOWN },
          { label: 'Slide In Up', value: slideDirection.SLIDE_IN_UP },
          { label: 'Slide In Left', value: slideDirection.SLIDE_IN_LEFT },
          { label: 'Slide In Right', value: slideDirection.SLIDE_IN_RIGHT },
        ];
      case AnimationEffection.ZOOMING:
        return [{ label: 'Zoom In', value: zoomDirection.ZOOM_IN }];
    }
  };

  const getEntranceDemoUrl = () => {
    switch (animation.effect) {
      case AnimationEffection.FADE: {
        switch (animation.direction) {
          case fadeDirection.FADE_IN:
            return `${ANIMATION_PREFIX}fade-in.gif`;
          case fadeDirection.FADE_IN_DOWN:
            return `${ANIMATION_PREFIX}fade-in-down.gif`;
          case fadeDirection.FADE_IN_LEFT:
            return `${ANIMATION_PREFIX}fade-in-left.gif`;
          case fadeDirection.FADE_IN_RIGHT:
            return `${ANIMATION_PREFIX}fade-in-right.gif`;
          case fadeDirection.FADE_IN_UP:
            return `${ANIMATION_PREFIX}fade-in-up.gif`;
        }
      }
      case AnimationEffection.SLIDE: {
        switch (animation.direction) {
          case slideDirection.SLIDE_IN_DOWN:
            return `${ANIMATION_PREFIX}slide-in-down.gif`;
          case slideDirection.SLIDE_IN_LEFT:
            return `${ANIMATION_PREFIX}slide-in-left.gif`;
          case slideDirection.SLIDE_IN_RIGHT:
            return `${ANIMATION_PREFIX}slide-in-right.gif`;
          case slideDirection.SLIDE_IN_UP:
            return `${ANIMATION_PREFIX}slide-in-up.gif`;
        }
      }
      case AnimationEffection.ZOOMING: {
        return `${ANIMATION_PREFIX}zoom-in.gif`;
      }
    }
  };

  const getHoverDemoUrl = () => {
    switch (animation.effectType) {
      case HoverEffect.GROW: {
        return `${ANIMATION_PREFIX}grow.gif`;
      }
      case HoverEffect.OVERLAY: {
        return `${ANIMATION_PREFIX}overlay.gif`;
      }
    }
  };

  const renderConfig = () => {
    switch (animation.animationType) {
      case AnimationType.EntranceEffect: {
        return (
          <>
            <SectionContainer bottomBorder>
              <Row
                elements={[
                  {
                    child: (
                      <>
                        <ItemWrapper title={'Animation Type'}>
                          <Select
                            size={'large'}
                            value={animation.effect}
                            onChange={(v) =>
                              _d(
                                onChangeField({
                                  uuid: animation.uuid,
                                  value: v,
                                  prop: 'effect',
                                }),
                              )
                            }
                            options={[
                              {
                                label: 'Fading',
                                value: AnimationEffection.FADE,
                              },
                              {
                                label: 'Slide',
                                value: AnimationEffection.SLIDE,
                              },
                              {
                                label: 'Zooming',
                                value: AnimationEffection.ZOOMING,
                              },
                            ]}
                          />
                        </ItemWrapper>
                        <ItemWrapper title={'Animation Direction'}>
                          <Select
                            size={'large'}
                            onChange={(v) =>
                              _d(
                                onChangeField({
                                  uuid: animation.uuid,
                                  value: v,
                                  prop: 'direction',
                                }),
                              )
                            }
                            value={animation.direction}
                            options={renderOptionsByEffectType()}
                          />
                        </ItemWrapper>
                        <ItemWrapper title={'Entrance Effect Option'}>
                          <RadioGroup
                            value={animation.option}
                            onChange={(e) =>
                              _d(
                                onChangeField({
                                  uuid: animation.uuid,
                                  value: e.target.value,
                                  prop: 'option',
                                }),
                              )
                            }>
                            <Space direction={'vertical'}>
                              <RadioItem value={EntranceOption.TOGETHER}>
                                {'Together'}
                              </RadioItem>
                              <RadioItem value={EntranceOption.ONE_BY_ONE}>
                                {'One by one'}
                              </RadioItem>
                            </Space>
                          </RadioGroup>
                        </ItemWrapper>
                      </>
                    ),
                  },
                  {
                    child: (
                      <SectionContainer
                        className={styles.paddingBottom}
                        size={'small'}>
                        <img
                          src={getEntranceDemoUrl()}
                          alt={'animation display'}
                        />
                      </SectionContainer>
                    ),
                  },
                ]}
              />
            </SectionContainer>
            <SectionContainer>
              <Row
                elements={[
                  {
                    child: (
                      <ItemWrapper
                        title={'Duration Time'}
                        rightSubTitle={
                          'Recommended duration time 1000 milliseconds'
                        }>
                        <Input
                          error={
                            specificError['durationMilliseconds'] &&
                            specificError['durationMilliseconds']?.length !== 0
                          }
                          help={specificError['durationMilliseconds']}
                          size={'large'}
                          suffix={'milliseconds'}
                          value={animation.durationMilliseconds}
                          onChange={(value) =>
                            _d(
                              onChangeField({
                                uuid: animation.uuid,
                                value,
                                prop: 'durationMilliseconds',
                              }),
                            )
                          }
                        />
                      </ItemWrapper>
                    ),
                  },
                  {
                    child:
                      animation.option !== EntranceOption.TOGETHER ? (
                        <ItemWrapper
                          title={'Interval Time'}
                          rightSubTitle={
                            'Recommended interval time 400 milliseconds'
                          }>
                          <Input
                            error={
                              specificError['intervalMilliseconds'] &&
                              specificError['intervalMilliseconds']?.length !==
                                0
                            }
                            help={specificError['intervalMilliseconds']}
                            size={'large'}
                            suffix={'milliseconds'}
                            value={animation.intervalMilliseconds}
                            onChange={(value) =>
                              _d(
                                onChangeField({
                                  uuid: animation.uuid,
                                  value,
                                  prop: 'intervalMilliseconds',
                                }),
                              )
                            }
                          />
                        </ItemWrapper>
                      ) : null,
                  },
                ]}
              />
            </SectionContainer>
          </>
        );
      }
      case AnimationType.HoverEffect: {
        return (
          <>
            <SectionContainer>
              <Row
                elements={[
                  {
                    child: (
                      <>
                        <ItemWrapper title={'Hover Effect Type'}>
                          <RadioGroup
                            value={animation.effectType}
                            onChange={(e) =>
                              _d(
                                onChangeField({
                                  uuid: animation.uuid,
                                  value: e.target.value,
                                  prop: 'effectType',
                                }),
                              )
                            }>
                            <Space direction={'vertical'}>
                              <RadioItem value={HoverEffect.OVERLAY}>
                                {'Overlay'}
                              </RadioItem>
                              <RadioItem value={HoverEffect.GROW}>
                                {'Grow'}
                              </RadioItem>
                            </Space>
                          </RadioGroup>
                        </ItemWrapper>
                        <ItemWrapper title={'Overlay Colour'}>
                          <ColorPicker
                            multi
                            color={animation.overlayColor}
                            onChange={(color) =>
                              _d(
                                onChangeField({
                                  uuid: animation.uuid,
                                  value: color,
                                  prop: 'overlayColor',
                                }),
                              )
                            }
                          />
                        </ItemWrapper>
                      </>
                    ),
                  },
                  {
                    child: (
                      <SectionContainer
                        className={styles.paddingBottom}
                        size={'small'}>
                        <img
                          src={getHoverDemoUrl()}
                          alt={'animation display'}
                        />
                      </SectionContainer>
                    ),
                  },
                ]}
              />
            </SectionContainer>
            <SectionContainer>
              <Row
                elements={[
                  {
                    child: (
                      <ItemWrapper
                        title={'Duration Time'}
                        rightSubTitle={
                          'Recommended interval time 400 milliseconds'
                        }>
                        <Input
                          error={
                            specificError['durationMilliseconds'] &&
                            specificError['durationMilliseconds']?.length !== 0
                          }
                          help={specificError['durationMilliseconds']}
                          size={'large'}
                          suffix={'milliseconds'}
                          value={animation.durationMilliseconds}
                          onChange={(v) =>
                            _d(
                              onChangeField({
                                uuid: animation.uuid,
                                value: v,
                                prop: 'durationMilliseconds',
                              }),
                            )
                          }
                        />
                      </ItemWrapper>
                    ),
                  },
                  { child: <></> },
                ]}
              />
            </SectionContainer>
          </>
        );
      }
    }
  };
  return (
    <React.Fragment>
      <SectionContainer bottomBorder>
        <ItemWrapper title={'Animation Type'}>
          <RadioGroup
            value={animation.animationType}
            onChange={(e) => {
              //console.log(e);
              _d(
                onChangeField({
                  uuid: animation.uuid,
                  prop: 'animationType',
                  value: e.target.value,
                }),
              );
            }}>
            <Space direction={'vertical'}>
              <RadioItem value={AnimationType.EntranceEffect}>
                {'Entrance Animation'}
              </RadioItem>
              <RadioItem value={AnimationType.HoverEffect}>
                {'Hover Effect'}
              </RadioItem>
            </Space>
          </RadioGroup>
        </ItemWrapper>
      </SectionContainer>
      <SectionContainer bottomBorder>
        <ItemWrapper
          title={`Name*`}
          rightSubTitle={'For internal use.'}
          rightPart={
            <CountWords allCount={100} count={animation.name?.length} />
          }>
          <Input
            error={specificError['name'] && specificError['name']?.length !== 0}
            help={specificError['name']}
            size={'large'}
            value={animation.name}
            onChange={(value) =>
              _d(onChangeField({ uuid: animation.uuid, prop: 'name', value }))
            }
          />
        </ItemWrapper>
      </SectionContainer>
      {renderConfig()}
    </React.Fragment>
  );
}

export default Item;
